export const ABOUT_US = "About Us";
export const ADHARVA_ORG_TEXT = "ADHARVA.ORG.IN © 2020";
export const ADHARVA_FOOTER_TEXT =
  "We welcome you to AIC to explore more and reach your goals.";
export const ADHARVA_GOOGLE_MAP =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d125243.76575845109!2d76.07260986315119!3d11.197424612650869!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba63b599c395a4b%3A0xdbb080e178143d64!2sAdharva%20Institute%20of%20Commerce%20-%20A%20I%20C!5e0!3m2!1sen!2sca!4v1711597096547!5m2!1sen!2sca";
export const ADHARVA_TITLE = "ADHARVA INSTITUTE FOR COMMERCE";
export const OUR_MISSION = "Our Mission";
export const OUR_VISION = "Our Vision";
